import * as React from 'react';
import { Translate } from 'react-localize-redux';

export const NotAssignedLabel = () => (
  <span style={ { color: '#ccc' } }>
    <Translate id="not-assigned"/>
  </span>
);